import { gql } from '@apollo/client';

const UPDATE_AFIB_HR_SUMMARY = gql`
  mutation updateAfibHrSummary($input: UpdateAfibHrSummaryInput!) {
    updateAfibHrSummary(input: $input) {
      isSuccess
      message
    }
  }
`;

export default UPDATE_AFIB_HR_SUMMARY;
